import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { superbillGoalsActions } from 'features/superbillGoals';

const useSuperbillGoals = () => {
  const dispatch = useDispatch();
  const getSuperbillGoals = useCallback(({ offset, query }) => dispatch(superbillGoalsActions.getSuperbillGoals({ offset, query })), [dispatch]);
  const getSuperbillGoal = useCallback(id => dispatch(superbillGoalsActions.getSuperbillGoal(id)), [dispatch]);
  const createSuperbillGoal = useCallback(superbill_goal => dispatch(superbillGoalsActions.createSuperbillGoal(superbill_goal)), [dispatch]);
  const updateSuperbillGoal = useCallback(superbill_goal => dispatch(superbillGoalsActions.updateSuperbillGoal(superbill_goal)), [dispatch]);
  const deleteSuperbillGoal = useCallback(id => dispatch(superbillGoalsActions.deleteSuperbillGoal(id)), [dispatch]);
  const clearLocalSuperbillGoals = useCallback(() => dispatch(superbillGoalsActions.clearLocalSuperbillGoals()), [dispatch]);
  const clearLocalActiveSuperbillGoal = useCallback(() => dispatch(superbillGoalsActions.clearLocalActiveSuperbillGoal()), [dispatch]);

  return {
    getSuperbillGoals,
    getSuperbillGoal,
    createSuperbillGoal,
    updateSuperbillGoal,
    deleteSuperbillGoal,
    clearLocalSuperbillGoals,
    clearLocalActiveSuperbillGoal
  };
};

export default useSuperbillGoals;